import {
  BriefcaseIcon,
  BuildingOffice2Icon,
  CalculatorIcon,
  ChatBubbleLeftRightIcon,
  ComputerDesktopIcon,
  HomeIcon,
  TruckIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";
import type { ContactIcon as ContactIconName, MarketFlag } from "@type/contact";

const ICONS = {
  accounting: CalculatorIcon,
  briefcase: BriefcaseIcon,
  building: BuildingOffice2Icon,
  chat: ChatBubbleLeftRightIcon,
  home: HomeIcon,
  it: ComputerDesktopIcon,
  service: WrenchScrewdriverIcon,
  truck: TruckIcon,
  users: UserGroupIcon,
} as const;

interface ContactIconProps {
  className?: string;
  name: ContactIconName | "home";
}

export const ContactIcon = ({ className, name }: ContactIconProps) => {
  const Icon = ICONS[name];
  return <Icon aria-hidden="true" className={className} />;
};

// Flagi jako SVG - emoji flag nie renderują się na Windows
const FLAG_STRIPES: Record<
  Exclude<MarketFlag, "cz">,
  { colors: string[]; direction: "horizontal" | "vertical" }
> = {
  de: { colors: ["#000000", "#DD0000", "#FFCE00"], direction: "horizontal" },
  fr: { colors: ["#0055A4", "#FFFFFF", "#EF4135"], direction: "vertical" },
  it: { colors: ["#009246", "#FFFFFF", "#CE2B37"], direction: "vertical" },
  pl: { colors: ["#FFFFFF", "#DC143C"], direction: "horizontal" },
};

const FLAG_WIDTH = 24;
const FLAG_HEIGHT = 16;

export const MarketFlagIcon = ({ flag }: { flag: MarketFlag }) => {
  if (flag === "cz") {
    return (
      <svg
        aria-hidden="true"
        className="h-4 w-6 shrink-0 rounded-[2px] ring-1 ring-black/10"
        viewBox={`0 0 ${FLAG_WIDTH} ${FLAG_HEIGHT}`}
      >
        <rect fill="#FFFFFF" height="8" width="24" />
        <rect fill="#D7141A" height="8" width="24" y="8" />
        <path d="M0 0 L12 8 L0 16 Z" fill="#11457E" />
      </svg>
    );
  }

  const { colors, direction } = FLAG_STRIPES[flag];
  const isHorizontal = direction === "horizontal";
  const stripeSize = (isHorizontal ? FLAG_HEIGHT : FLAG_WIDTH) / colors.length;

  return (
    <svg
      aria-hidden="true"
      className="h-4 w-6 shrink-0 rounded-[2px] ring-1 ring-black/10"
      viewBox={`0 0 ${FLAG_WIDTH} ${FLAG_HEIGHT}`}
    >
      {colors.map((color, index) => (
        <rect
          fill={color}
          height={isHorizontal ? stripeSize : FLAG_HEIGHT}
          key={color}
          width={isHorizontal ? FLAG_WIDTH : stripeSize}
          x={isHorizontal ? 0 : index * stripeSize}
          y={isHorizontal ? index * stripeSize : 0}
        />
      ))}
    </svg>
  );
};
